import { FC } from 'react';
import useThemeComponents from '../../hooks/useThemeComponents';

export const getThemesComponent = <TProps extends object>(
  DefaultComponent: React.FC<TProps>,
  name: string
): FC<TProps> => {
  return (props: TProps) => {
    const ContextComponent = useThemeComponents();
    const Component = ContextComponent[name] || DefaultComponent;

    return <Component {...props} />;
  };
};
